// @todo Remove DC closure messaging when back in operation - SHOP-626
import React from 'react'
import Notification from '@ynap/notification'
import BEMHelper from '@ynap/bem-helper';

export const getCrisisNotification: GetCrisisNotification = (bem, isBag = false, crisisMessages = {}) => {
    let message = crisisMessages?.empty ? '' : crisisMessages?.checkoutStep?.text
    if (isBag && !crisisMessages?.empty) message = crisisMessages?.shoppingBag?.text

    return message ? (
        <Notification className={bem('shippingDelays')} message={message} />
    ) : null
}

interface CrisisMessage {
    text?: string;
    title?: string;
    empty?: boolean;
}

interface CrisisMessages {
    [key: string]: CrisisMessage
}

interface GetCrisisNotification {
    (bem: BEMHelper, isBag?: boolean, crisisMessages?: CrisisMessages): JSX.Element | null
}